import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSms = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 0.25C1.175 0.25 0.5 0.925 0.5 1.75V9.84473C0.5 10.1785 0.903887 10.3461 1.14014 10.1099L2.75 8.5H9.5C10.325 8.5 11 7.825 11 7V1.75C11 0.925 10.325 0.25 9.5 0.25H2ZM12.5 4V7C12.5 8.65675 11.1567 10 9.5 10H5V10.75C5 11.575 5.675 12.25 6.5 12.25H13.25L14.8599 13.8599C15.0961 14.0961 15.5 13.9285 15.5 13.5947V5.5C15.5 4.675 14.825 4 14 4H12.5Z",
		fill: "#4F9A6A"
	})]
});
const ForwardRef = forwardRef(SvgSms);
export { ForwardRef as ReactComponent };
